import { render, staticRenderFns } from "./NewTarget.vue?vue&type=template&id=b358d798&scoped=true"
import script from "./NewTarget.vue?vue&type=script&lang=js"
export * from "./NewTarget.vue?vue&type=script&lang=js"
import style0 from "./NewTarget.vue?vue&type=style&index=0&id=b358d798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b358d798",
  null
  
)

export default component.exports